import React from 'react'
import Tooltip from '../../../../ui/tooltips/Tooltip'

import '../../../../../assets/sass/pages/landing/pricing/components/club-card.scss'

const ClubCard = ({ name, image }) => {
    return (
        <div className="club-card">
            <Tooltip text={name}>
                <img src={image} alt={name} className="club-card--image" />
            </Tooltip>
        </div>
    )
}

export default ClubCard
